import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EditorService} from '../../../../../services/editor.service';

export class MemberOption {
    id: number;
    value: string;
}

@Component({
    selector: 'app-resumes-editor-settings',
    templateUrl: './resumes-editor-settings.component.html',
    styleUrls: ['./resumes-editor-settings.component.scss']
})
export class ResumesEditorSettingsComponent implements OnInit, OnChanges {
    rows: any[] = [];
    mode: string;
    form: any;
    row: any;
    member: any;
    title: string;
    option: MemberOption;
    @Input() data: any;
    @Output() closeEvent: EventEmitter<any>;
    @Output() startLinking: EventEmitter<any> = new EventEmitter<any>();
    linking = {
        isLinking: false,
        id: -1
    };

    constructor(private editorService: EditorService) {
        this.closeEvent = new EventEmitter<any>();

    }

    ngOnInit(): void {
        this.initializeComponent(this.data);
    }

    initializeComponent(data) {
        this.mode = data.mode;
        this.title = data.title;
        this.clearOption();
        switch (data.mode) {
            case 'row':
                this.row = data.row;
                this.rows = data.rows;
                break;
            case 'member':
                this.member = data.member;
                if (!this.member.twoFactor) {
                    this.member.twoFactor = {
                        isTwoFactorField: false,
                        types: ['sms', 'email'],
                        selectedType: ''
                    };
                }
                break;
            default:
                this.form = data.form;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.initializeComponent(changes.data.currentValue);
    }

    close(data?: any) {
        this.closeEvent.emit({status: false, data});
    }

    htmlValueChanged(data) {
        this.member.value = data;
    }

    htmlValueChangedEnglish(data) {
        this.member.valueEN = data;
    }

    save() {
        switch (this.mode) {
            case 'row':
                this.close(this.row);
                break;
            case 'member':
                this.close(this.member);
                break;
            default:
                this.close(this.form);
        }
    }

    clearOption() {
        this.option = {
            id: 0,
            value: ''
        };
    }

    addOption() {
        const option: MemberOption = {
            id: this.member.options.length + 1,
            value: this.option.value
        };
        this.member.options.push(option);
        this.clearOption();
    }

    removeOption(id: number) {
        const optionIndex = this.member.options.findIndex(option => option.id === id);
        if (optionIndex !== -1) {
            this.member.options.splice(optionIndex, 1);
        }
    }

    link(option: any) {
        this.linking = {
            isLinking: true,
            id: option.id
        };
        this.startLinking.emit({active: true, value: option});
    }

    doneLinking() {
        this.linking = {
            isLinking: false,
            id: -1
        };
        this.startLinking.emit({active: false, value: null});
    }

    moveDown(id: number) {
        const options = [...this.member.options];
        const currentOptionIndex = options.findIndex(r => r.id === id);
        if (currentOptionIndex - 1 < options.length) {
            const nextIndex = currentOptionIndex + 1;
            const tempOption = options[nextIndex];
            options[nextIndex] = options[currentOptionIndex];
            options[currentOptionIndex] = tempOption;
        }

        this.member.options = options;
    }

    moveUp(id: number) {
        const options = [...this.member.options];
        const currentOptionIndex = options.findIndex(r => r.id === id);
        if (currentOptionIndex !== -1 && currentOptionIndex !== 0) {
            const previousIndex = currentOptionIndex - 1;
            const tempRow = options[previousIndex];
            options[previousIndex] = options[currentOptionIndex];
            options[currentOptionIndex] = tempRow;
        }

        this.member.options = options;
    }

    shouldDisableUpButton(id: number): boolean {
        const currentOptionIndex = this.member.options.findIndex(r => r.id === id);
        return currentOptionIndex <= 0;
    }

    shouldDisableDownButton(id: number): boolean {
        const currentOptionIndex = this.member.options.findIndex(r => r.id === id);
        return currentOptionIndex >= this.member.options.length - 1;
    }

    addColumn() {
        const newMember = this.editorService.createMember(this.row.members.length + 1);
        this.row.members.push(newMember);
        this.row.columns++;
    }

    removeColumn() {
        if (this.row.columns > 0) {
            this.row.members.splice(this.row.members.length - 1, 1);
            this.row.columns--;
        }
    }

    duplicateColumn() {
        const index = this.rows.findIndex(r => r.id === this.row.id);
        const newRow = JSON.parse(JSON.stringify(this.row));
        newRow.id++;
        newRow.parentId = this.row.id;
        newRow.members.map(m => m.isLabelHidden = true);

        // add duplicate row with hidden Labels in controls BELOW the parent row
        this.rows.splice(index + 1, 0, newRow);
    }

    sliderValueChange($event: number, row: any) {
        console.log($event);
        this.row.title.margin = `${$event}px`;
    }

    currentValue(margin: string) {
        const data = margin.split('px');
        return +data[0];
    }
}
